import errorDogPng from './error-dog.png';
import errorDogWebP from './error-dog.webp';

export const errorDogSources = [errorDogPng, errorDogWebP];
